<template>
  <el-table
    :data="data"
    border
    style="width: 100%"
    v-loading="loading"
  >
    <el-table-column
      prop="giftId"
      :label="$t('integralShopGift.id')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="ruleId"
      :label="$t('integralShopGift.rule')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="ruleName"
      :label="$t('integralShopGift.ruleName')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="quantity"
      :label="$t('integralShopGift.quantity')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="personId"
      :label="$t('integralShopGift.personId')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="personName"
      :label="$t('integralShopGift.personName')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="tel"
      :label="$t('integralShopGift.tel')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="personIntegralId"
      :label="$t('integralShopGift.accountId')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="personIntegralName"
      :label="$t('integralShopGift.accountName')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="integralDetailId"
      :label="$t('integralShopGift.detailId')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="remark"
      :label="$t('integralShopGift.remark')"
      align="center"
    ></el-table-column>
    <el-table-column
      prop="createTime"
      :label="$t('integralShopGift.createTime')"
      align="center"
    ></el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'IntegralShopGiftTable',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.el-table {
  margin-bottom: 20px;
}
</style>